export default "__VITE_ASSET__5VJi5QB0__"